import { Controller } from "@hotwired/stimulus"

// Keeps a text input in Brazilian money shape ("1.234,56") while typing.
export default class extends Controller {
  connect() {
    this.element.addEventListener("input", this.format)
    this.format()
  }

  disconnect() {
    this.element.removeEventListener("input", this.format)
  }

  format = () => {
    const digits = this.element.value.replace(/\D/g, "")
    if (!digits) return
    const cents = parseInt(digits, 10)
    const whole = Math.floor(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    const frac = (cents % 100).toString().padStart(2, "0")
    this.element.value = `${whole},${frac}`
  }
}
